import ReactQuoraPixel from "react-quora-pixel";

export function initializeQuoraPixel() {
    const options = {
        debug: false, 		// enable logs
    };
    ReactQuoraPixel.init("57dce12f74104d808c866ef2b6cedcc5", null, options);
}
export function logQuoraPixelEvent(event, data) {
    ReactQuoraPixel.track(event, data);
}
